import type { ColumnTypeFn } from "./types";
import { textType } from "./types/text";
import { booleanType } from "./types/boolean";
import { datetimeType } from "./types/datetime";
import { dateType } from "./types/date";
import { timeType } from "./types/time";
import { numberType } from "./types/number";
import { relatedType } from "./types/related";
import { saveHtmlType } from "./types/save_html";
import { jsonType } from "./types/json";

export type { ColumnTypeFn };

export const columnTypes: Record<string, ColumnTypeFn> = {
  text: textType,
  boolean: booleanType,
  datetime: datetimeType,
  date: dateType,
  time: timeType,
  number: numberType,
  related: relatedType,
  save_html: saveHtmlType,
  json: jsonType,
};

export function getColumnType(name: string): ColumnTypeFn | undefined {
  return columnTypes[name];
}
